const emailValidation = Object.freeze({
  pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, //eslint(no-useless-escape)
});

const isAValidEmailAddress = (email) => {
  return email && email.length > 0 && email.match(emailValidation.pattern);
};

const isValidISODateString = (isoUtcDateString) =>
  isoUtcDateString &&
  isoUtcDateString.length > 0 &&
  (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(isoUtcDateString) ||
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{7}Z/.test(isoUtcDateString));

export { emailValidation, isAValidEmailAddress, isValidISODateString };
